export const RURALIDAD_ETIQUETA: Record<string, string> = {
  urbano: 'Urbano',
  rural: 'Rural',
  ambos: 'Ambos',
};

export const RURALIDAD_ESTILO: Record<string, string> = {
  urbano: 'bg-blue-50 text-blue-700',
  rural: 'bg-marca-50 text-marca-700',
  ambos: 'bg-armazon-100 text-armazon-700',
};

/**
 * El código del destino tarifario, escrito como se lee.
 *
 * <p>En el catastro conviven dos formas de escribirlo: la de ahora —`bt_residencial_urbano`— y
 * la que vino del sistema anterior —`BT Residencial`, sin zona, en 809 cuentas—. Las dos
 * significan lo mismo y en una lista aparecían como si fueran categorías distintas.
 *
 * <p>El «BT» se cae: es de baja tensión, viene de cuando la tasa se cobraba con la planilla de
 * luz, y como lo son todas no distingue nada. Y «industrial artesanal» se escribe con su
 * conjunción, que es como se llama la categoría.
 */
export function nombreLegible(tipoCliente: string): string {
  return tipoCliente
    .trim()
    .replace(/^bt[\s_]+/i, '')
    .replace(/_/g, ' ')
    .toLowerCase()
    .replace('industrial artesanal', 'industrial y artesanal');
}

export function tituloDeTarifa(tarifa: {
  descripcion?: string | null;
  tipoCliente: string;
}): string {
  return tarifa.descripcion?.trim() || nombreLegible(tarifa.tipoCliente);
}

export function formatearTasa(porcentaje: number): string {
  const dos = porcentaje.toFixed(2);
  return Number(dos) === Number(porcentaje.toFixed(6)) ? dos : porcentaje.toFixed(4);
}
